<section id="content">
  <div class="row">
    <div class="col-md-12 col-xs-12 table-cont">
      <div class="form-group">
        <div class="card">
          <div class="card-title">
            PDF File Conversion
            <i class="collapse-icon fa"></i>
          </div>

       

          <div class="card customer-select">
          


            <!-- <div class="card-header">

              <label for="fileType">ٍSelect User</label>
              <p-dropdown 
                id="fileTypes" 
                [options]="SalesUsers" 
                placeholder="Select User"
                optionLabel="label" 
                optionValue="value" 
                class="full-width" 
                [(ngModel)]="selectedSalesUser" 
                [showClear]="true" 
                required="true">
              </p-dropdown>
            </div> -->

            <div class="card-header">
              <label for="fileType">Choose a conversion type</label>
              <p-dropdown 
                id="fileTypes" 
                [options]="fileTypes" 
                placeholder="Select Conversion Type"
                optionLabel="label" 
                optionValue="value" 
                class="full-width" 
                [(ngModel)]="selectedOption" 
                [showClear]="true" 
                required="true">
              </p-dropdown>
            </div>
          </div>

          <!-- File Upload Section -->
          <div class="cont group" *ngIf="selectedOption" >

            <div class="table-responsive">
              <div class="group">
                <div class="collapse-title">
                  Upload PDF File
                </div>

                <div [hidden]="value <=0" class="group-cont">
                  <p-toast />
                  <p-progressBar [value]="value" />
              </div>

                <div class="collapse in show" id="group-2">
                  <div class="group-cont">
                    <div class="input-attachment">
                      <p-fileUpload 
                        name="file" 
                        [url]="apiEndpoint" 
                        uploadLabel="Convert"
                        method="POST"
                        [multiple]="true" 
                        [disabled]="isLoading"
                        [showCancelButton]="!isLoading"
                        [showUploadButton]="!isLoading"
                        customUpload="true"
                        [maxFileSize]="1000000" 
                        accept=".pdf" 
                        (uploadHandler)="onUpload($event)" 
                        (onClear)="onClear()"
                        [files]="uploadedFiles"> 
                       
                      </p-fileUpload>
                    </div>
                  </div>
                </div>
              </div>
<!-- 
              <p-button 
                [disabled]="!selectedFile || isLoading" 
                mat-raised-button 
                color="primary" 
                (click)="onSubmit()">Convert File</p-button> -->

              <!-- Loading spinner -->
              <div *ngIf="isLoading" class="loading-spinner">
                <p >Converting...</p>
                <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</section>
